export const DELETE_ALERT = 'cx-ray/EMPLOYEE/ALERT/DELETE_ALERT ';
export const ADD_ALERT = 'cx-ray/EMPLOYEE/ALERT/ADD_ALERT ';

export function deleteAlert() {
  return ({
    type: DELETE_ALERT
  });
}

export function addAlert(alert) {
  return ({
    type: ADD_ALERT,
    payload: alert
  });
}